export default __webpack_public_path__ + "static/media/telegram.224cb085.svg";